import React, { useEffect, useRef } from "react";
import dayjs from "dayjs";
import DateLogic from "../../utils/DateLogic";
import { formatTimeRange, format12Hour } from "../../utils/FormatTime";
import "../../CSS/WeddingDetails.css";
import useFadeOnScroll from "../../hooks/useFadeOnScroll";
import { Button } from '@mui/material';
import { Send } from "lucide-react";
import '../../index.css';
import { getTranslations } from "../../utils/CardTranslations";


const WeddingDetails = ({ data, programmes }) => {

  const openingRef = useRef(null);
  const greetingRef = useRef(null);
  const coupleRef = useRef(null);
  const couple2Ref = useRef(null);
  const closingRef = useRef(null);
  const dateRef = useRef(null);
  const timeRef = useRef(null);
  const placeRef = useRef(null);
  const dressCodeRef = useRef(null);
  const programmeRef = useRef(null);
  const confirmRSVPRef = useRef(null);

  useFadeOnScroll(openingRef);
  useFadeOnScroll(greetingRef);
  useFadeOnScroll(coupleRef);
  useFadeOnScroll(couple2Ref);
  useFadeOnScroll(closingRef);
  useFadeOnScroll(dateRef);
  useFadeOnScroll(timeRef);
  useFadeOnScroll(placeRef);
  useFadeOnScroll(dressCodeRef);
  useFadeOnScroll(programmeRef);
  useFadeOnScroll(confirmRSVPRef);

  const designTemplate = data.designTemplate;
  const isClassicTemplate = designTemplate === "classic";
  const t = getTranslations(data.language);




  const buttonStyle = {
    marginTop: 3,
    textTransform: "none",
    border: "none",
    gap: 1,
    color: data.themeColour,
    backgroundColor: data?.buttonColour || 'white',
    borderRadius: "50px",
    fontSize: "12px",
    px: "15px",
    py: "8px",
    boxShadow: '0 8px 16px 0 rgba(0,0,0,0.15)',
    "&:hover": {
      transition: "0.4s",
    },
  };

  return (
    <div
      style={{
        fontFamily: data.fontStyle,
        color: data.themeColour,
        textAlign: "center",
      }}
    >

      <div style={{ padding: "30px" }}>
        {/* Opening Text */}

        <div className="fade-section" ref={openingRef}>

          {data.openingText && (
            <p style={{ fontSize: "15px", fontStyle: "italic", marginTop: "12px" }}>
              {data.openingText}
            </p>
          )}

          {/* Parent Names */}
          {data.eventHost === "satu" && data.parentName && (
            <p
              style={{
                fontSize: data.parentName?.length > 55 ? "22px" : "25px",
                whiteSpace: "pre-line",
                marginTop: "20px",
                fontFamily: data.fontNamingStyle,
              }}
            >
              {data.parentName.replace(/ & /g, "\n&\n")}
            </p>
          )}
          {data.eventHost === "dua" && (
            <>
              {data.parentNameMale && (
                <div style={{ marginTop: "20px" }}>
                  <p style={{ fontSize: "12px", margin: 0 }}>{t.groomSide}</p>
                  <p
                    style={{
                      fontSize: data.parentNameMale?.length > 55 ? "22px" : "25px",
                      whiteSpace: "pre-line",
                      margin: 0,
                      fontFamily: data.fontNamingStyle,
                    }}
                  >
                    {data.parentNameMale.replace(/ & /g, "\n&\n")}
                  </p>
                </div>
              )}
              <p style={{ fontSize: "13px", marginTop: "12px" }}>{t.and}</p>
              {data.parentNameFemale && (
                <div style={{ marginTop: "12px" }}>
                  <p style={{ fontSize: "12px", margin: 0 }}>{t.brideSide}</p>
                  <p
                    style={{
                      fontSize: data.parentNameFemale?.length > 55 ? "22px" : "25px",
                      whiteSpace: "pre-line",
                      margin: 0,
                      fontFamily: data.fontNamingStyle,
                    }}
                  >
                    {data.parentNameFemale.replace(/ & /g, "\n&\n")}
                  </p>
                </div>
              )}
            </>
          )}

        </div>

        {/* Greeting */}
        {data.greetingText && (
          < p ref={greetingRef} className="fade-section" style={{ fontSize: "15px", whiteSpace: "pre-line", marginTop: "20px" }}>
            {data.greetingText.replace(/\\n/g, "\n")}
          </p>
        )}

        {/* Couple Names */}
        {data.groomName && data.brideName ? (
          <p
            ref={coupleRef}
            className="fade-section"
            style={{
              fontSize: data.fontSizeNaming || "25px",
              whiteSpace: "pre-line",
              marginTop: "20px",
              fontFamily: data.fontNamingStyle,
            }}
          >
            {data.eventHost === "satu"
              ? data.eventSide === "lelaki"
                ? <>
                  {data.groomName} <br />&<br /> {data.brideName}
                </>
                : <>
                  {data.brideName} <br />&<br /> {data.groomName}
                </>
              : <>
                {data.groomName} <br />&<br /> {data.brideName}
              </>
            }
          </p>
        ) : (
          <>
            {data.groomName && (
              <p
                style={{
                  fontSize: "25px",
                  whiteSpace: "pre-line",
                  marginTop: "20px",
                  fontFamily: data.fontNamingStyle,
                }}
              >
                {data.groomName}
              </p>
            )}
            {data.brideName && (
              <p
                style={{
                  fontSize: "25px",
                  whiteSpace: "pre-line",
                  marginTop: "20px",
                  fontFamily: data.fontNamingStyle,
                }}
              >
                {data.brideName}
              </p>
            )}
          </>
        )}

        {/* ── COUPLE 2 section — same parent, 2nd child getting married ── */}
        {data.coupleCount === 'dua' && (
          <div ref={couple2Ref} className="fade-section">
            <div style={{ margin: '30px 0 10px', borderTop: '2px solid currentColor', opacity: 0.2 }} />

            {/* Couple 2 names only — shared parent from above */}
            {data.groomName2 && data.brideName2 ? (
              <p style={{
                fontSize: data.fontSizeNaming || '25px',
                whiteSpace: 'pre-line',
                marginTop: '15px',
                fontFamily: data.fontNamingStyle,
              }}>
                {data.eventHost === "satu"
                  ? data.eventSide === "lelaki"
                    ? <>
                      {data.groomName2} <br />&<br /> {data.brideName2}
                    </>
                    : <>
                      {data.brideName2} <br />&<br /> {data.groomName2}
                    </>
                  : <>
                    {data.groomName2} <br />&<br /> {data.brideName2}
                  </>
                }
              </p>
            ) : (
              <>
                {data.groomName2 && (
                  <p style={{ fontSize: '25px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>
                    {data.groomName2}
                  </p>
                )}
                {data.brideName2 && (
                  <p style={{ fontSize: '25px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>
                    {data.brideName2}
                  </p>
                )}
              </>
            )}
          </div>
        )}

        {/* Closing Text */}
        {data.closingText && (
          <p ref={closingRef} className="fade-section" style={{ fontSize: "15px", marginTop: "20px" }}>
            {data.closingText}
          </p>
        )}

        <div ref={dateRef} className="fade-section">
          {/* Date */}
          <p style={{ fontSize: "15px", marginTop: "20px", fontWeight: "bold" }}>
            {t.date}
          </p>
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "14px",
              gap: "5px",
            }}
          >
            <p>{DateLogic.toDay(dayjs(data.eventDate).format("dddd"), data.language)},</p>
            <p>{DateLogic.formatDate(data.eventDate, "D MMM YYYY", data.language)}</p>
          </span>
          {DateLogic.toIslamicDate(data.eventDate, data.language) && (
            <p style={{ fontSize: "12px", marginTop: "1px", opacity: 0.85 }}>
              ( {DateLogic.toIslamicDate(data.eventDate, data.language)} )
            </p>
          )}
        </div>

        {/* Time */}
        <div ref={timeRef} className="fade-section">
          <p style={{ fontSize: "15px", marginTop: "20px", fontWeight: "bold" }}>
            {t.time}
          </p>
          <p style={{ fontSize: "14px" }}>
            {formatTimeRange(data.startTime, data.endTime)}
          </p>
        </div>

        {/* Place */}
        <div ref={placeRef} className="fade-section">
          <p style={{ fontSize: "15px", marginTop: "20px", fontWeight: "bold" }}>
            {t.venue}
          </p>
          {data.eventAddress && (
            <p style={{ fontSize: "14px", whiteSpace: "pre-line" }}>
              {data.eventAddress}
            </p>
          )}
        </div>

        {/* Dress Code */}
        <div ref={dressCodeRef} className="fade-section">
          {data.showDressCode && (
            <>
              <p style={{ fontSize: "15px", marginTop: "20px", fontWeight: "bold" }}>
                {t.dressCode}
              </p>
              <p style={{ fontSize: "14px" }}>{data.dressCode}</p>

              {/* Colour palette swatches */}
              {Array.isArray(data.dressCodeColours) && data.dressCodeColours.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '8px', flexWrap: 'wrap' }}>
                  {data.dressCodeColours.map((colour, i) => (
                    <div
                      key={i}
                      title={colour}
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backgroundColor: colour,
                        boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                        flexShrink: 0,
                      }}
                    />
                  ))}
                </div>
              )}

              {/* Notes */}
              {data.dressCodeNotes && (
                <p style={{ fontSize: "12px", marginTop: "8px", opacity: 0.7, fontStyle: "italic", whiteSpace: "pre-line" }}>
                  {data.dressCodeNotes}
                </p>
              )}
            </>
          )}
        </div>

        {(data.packageType != "Basic" || data.showRSVP) && (
          <div ref={confirmRSVPRef} className="fade-section">
            <Button
              variant="outlined"
              sx={buttonStyle}
              onClick={() => {
                window.dispatchEvent(new Event("open-rsvp"));
              }}
            >
              <Send size={15} />
              {t.confirmAttendance}
            </Button>
          </div>
        )}
      </div>

      {isClassicTemplate && (
        <div
          style={{
            backgroundImage: `url(/card-backgrounds/lineClassic.png)`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            width: "100%",
            backgroundSize: "95%",
            backgroundPosition: "center",
            minHeight: "5vh",
          }}
        >
        </div>
      )}


      {/* Programme Schedule */}
      <div
        style={{
          backgroundColor: isClassicTemplate ? "transparent" : data.themeAturCaraColour,
          width: "100%",
          paddingTop: "30px",
          paddingBottom: "15px",
          color: isClassicTemplate ? data.themeColour : '#ffffff'
        }}
      >
        <div ref={programmeRef} className="fade-section">


          <p style={{ fontSize: "15px", fontWeight: "bold" }}>
            {t.programmeTitle}
          </p>
          {programmes.length > 0 ? (
            programmes.map((p) => (
              <div
                key={p.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  whiteSpace: "pre-line",
                  fontSize: "14px",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <span>{format12Hour(p.time)}</span>
                <span>{p.activity}</span>
              </div>
            ))
          ) : (
            <p style={{ fontSize: "13px", opacity: 0.8 }}>
              {t.programmeEmpty}
            </p>
          )}
        </div  >
      </div>

    </div >
  );
};

export default WeddingDetails;
